import { useUpdateChannelChannelUpdatePostMutation } from '@shared/api';
import { useState } from 'react';

export const useActivateChannel = () => {
  const [updateChannelMutation, { isLoading }] = useUpdateChannelChannelUpdatePostMutation();
  const [loadingChannelId, setLoadingChannelId] = useState<number | null>(null);

  const updateChannel = async (channelId: number, status: boolean) => {
    setLoadingChannelId(channelId);
    try {
      await updateChannelMutation({
        channelId,
        updateChannel: {
          is_active: status,
        },
      }).unwrap();
    } catch (error) {
    } finally {
      setLoadingChannelId(null);
    }
  };

  return {
    updateChannel,
    isLoading,
    loadingChannelId,
  };
};
